import styled from 'styled-components';
import {
  StyledButtonPrimary,
  StyledButtonTransparent
} from '../../../_shared/components/Button/Styles';

export const StyledTutorialNegotiationHeader = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledTutorialNegotiationContainer = styled.div`
  padding: 36px;
`;

export const StyledTutorialListItem = styled.li`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-top: 24px;
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 20px;
  margin-left: 10px;
  text-indent: -20px;
  padding-left: 20px;
`;

export const StyledTutorialFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
`;

export const StartNegotiationButton = styled(StyledButtonPrimary)`
  margin-top: 21px;
  margin-left: 24px;
  padding: 12px;
`;
export const CancelButton = styled(StyledButtonTransparent)`
  margin-top: 0px;
`;
